module.exports = __webpack_public_path__ + "img/logo6.f7ac16f1.png";